import { useState } from "react";
import { supabase } from "@/libs/supabase";
import type { Channel } from "@/types/channel/channel";

interface UpdateChannelData {
	name: string;
	description?: string;
	type: Channel["type"];
	emoji?: string;
	isDefault: boolean;
}

export const useUpdateChannel = () => {
	const [loading, setLoading] = useState(false);

	const updateChannel = async (channelId: string, data: UpdateChannelData) => {
		setLoading(true);
		try {
			const { data: channel, error } = await supabase
				.from("channels")
				.update({
					name: data.name,
					description: data.description,
					type: data.type,
					emoji: data.emoji,
					is_default: data.isDefault,
				})
				.eq("id", channelId)
				.select()
				.single();

			if (error) throw error;
			return channel;
		} finally {
			setLoading(false);
		}
	};

	return { updateChannel, loading };
};
